import {DocumentFormatFamilies} from '../constants';

export const isDocumentFileTypeAsset = (fileFormatFamily: string[]) =>
	fileFormatFamily.some((format) =>
		DocumentFormatFamilies.includes(
			format as typeof DocumentFormatFamilies[number],
		),
	);

export default isDocumentFileTypeAsset;
